"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageExportType = void 0;
var core_api_1 = require("@ikegps/core-api");
// support legacy 'measurements' parameter. Should use 'measurement' instead
var getImageExportType = function (captureFormatParts) {
    if (captureFormatParts.includes('measurements')) {
        return core_api_1.ExportableImageType.MEASUREMENT;
    }
    return captureFormatParts.find(function (part) { return Object.values(core_api_1.ExportableImageType).includes(part); });
};
exports.getImageExportType = getImageExportType;
//# sourceMappingURL=image.js.map